import {CaosCommand} from "../caos-def";
import {VAR_TYPE__COMMAND} from "../utils.variable_types";


type RLValueProps = {
    command: CaosCommand;
}

export default function RLValueTag({command}: RLValueProps) {
    let classNames = "rl-value";
    if (command.return_type_id === VAR_TYPE__COMMAND) {
        classNames += " command";
    }
   return <div className={classNames} aria-hidden="true">
            <span className={"rvalue " + (command.rvalue ? "selected" : "")}>R</span>
            <span className={"lvalue " + (command.lvalue ? "selected" : "")}>L</span>
    </div>
}